import React from 'react';

import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface McpDeleteConfirmDialogProps {
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
  open: boolean;
  disabled?: boolean;
}

const McpDeleteConfirmDialog: React.FC<McpDeleteConfirmDialogProps> = ({
  isLoading,
  onClose,
  onConfirm,
  open,
  disabled = false,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={isLoading ? undefined : onClose}
      aria-labelledby="delete-dialog-title">
      <DialogTitle id="delete-dialog-title">{t('mcpTools.deleteConfirmTitle')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('mcpTools.deleteConfirmMessage')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>
          {t('common.cancel')}
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={isLoading || disabled}>
          {isLoading ? <CircularProgress size={20} color="inherit" /> : t('common.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default McpDeleteConfirmDialog;
